(function() {
  'use strict';

  var FORM_ID = 'UKrJrH';
  var DEBUG_PARAM = 'debug_exit';
  var INACTIVITY_MS = 60 * 1000;
  var MAX_SHOWS_PER_DAY = 2;
  var STORAGE_KEY = 'st_exit_intent_cart_state_v1';

  var cartItemCount = 0;
  var lastAddToCartTime = 0;
  var inactivityTimer = null;
  var isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  var debugForceOpen = new URLSearchParams(window.location.search).get(DEBUG_PARAM) === '1';

  function todayKey() {
    var d = new Date();
    var month = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + month + '-' + day;
  }

  function readState() {
    var fallback = {
      day: todayKey(),
      showsToday: 0,
      lastPopupShownTime: 0,
      lastAddToCartTime: 0
    };

    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return fallback;
      return {
        day: typeof parsed.day === 'string' ? parsed.day : fallback.day,
        showsToday: Number(parsed.showsToday) || 0,
        lastPopupShownTime: Number(parsed.lastPopupShownTime) || 0,
        lastAddToCartTime: Number(parsed.lastAddToCartTime) || 0
      };
    } catch (error) {
      return fallback;
    }
  }

  function writeState(partial) {
    try {
      var current = readState();
      var next = {
        day: current.day,
        showsToday: current.showsToday,
        lastPopupShownTime: current.lastPopupShownTime,
        lastAddToCartTime: current.lastAddToCartTime
      };

      Object.assign(next, partial || {});
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      // Ignore storage errors (private mode / quota).
    }
  }

  function resetStateIfNewDay() {
    var state = readState();
    var today = todayKey();
    if (state.day === today) return state;

    var reset = {
      day: today,
      showsToday: 0,
      lastPopupShownTime: state.lastPopupShownTime,
      lastAddToCartTime: state.lastAddToCartTime
    };
    writeState(reset);
    return reset;
  }

  function openKlaviyoForm() {
    var maxAttempts = 12;
    var retryDelayMs = 250;
    var attempts = 0;

    return new Promise(function(resolve) {
      function tryOpen() {
        if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
          window.klaviyo.openForm(FORM_ID);
          resolve(true);
          return;
        }

        attempts += 1;
        if (attempts >= maxAttempts) {
          resolve(false);
          return;
        }

        setTimeout(tryOpen, retryDelayMs);
      }

      tryOpen();
    });
  }

  function shouldFire() {
    if (cartItemCount <= 0) return false;

    var state = resetStateIfNewDay();
    var showsToday = Number(state.showsToday) || 0;

    if (showsToday >= MAX_SHOWS_PER_DAY) return false;

    if (showsToday === 0) return true;

    var lastShown = Number(state.lastPopupShownTime) || 0;
    var lastAdd = Math.max(lastAddToCartTime, Number(state.lastAddToCartTime) || 0);

    return lastAdd > lastShown;
  }

  function markShown() {
    var state = resetStateIfNewDay();
    writeState({
      day: todayKey(),
      showsToday: (Number(state.showsToday) || 0) + 1,
      lastPopupShownTime: Date.now(),
      lastAddToCartTime: Math.max(lastAddToCartTime, Number(state.lastAddToCartTime) || 0)
    });
  }

  function attemptPopup(force) {
    if (!force && !shouldFire()) return false;

    openKlaviyoForm().then(function(opened) {
      if (!opened) return;

      if (!force) {
        markShown();
      }
    });

    return true;
  }

  function updateAddToCartTimestamp(timestamp) {
    var ts = timestamp || Date.now();
    lastAddToCartTime = ts;
    writeState({ lastAddToCartTime: ts });
  }

  function setCartItemCountFromCart(cart) {
    if (cart && typeof cart.item_count === 'number') {
      cartItemCount = cart.item_count;
    }
  }

  function refreshCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function(cart) {
        setCartItemCountFromCart(cart);
        return cart;
      })
      .catch(function() {
        return null;
      });
  }

  function isCartMutationUrl(url) {
    return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
  }

  function isAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function patchFetch() {
    if (!window.fetch) return;

    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = getRequestUrl(input);
      var isMutation = isCartMutationUrl(url);
      var isAdd = isAddUrl(url);

      return originalFetch.call(this, input, init).then(function(response) {
        if (!isMutation || !response || !response.ok) return response;

        if (isAdd) {
          updateAddToCartTimestamp();
        }

        refreshCartCount();
        return response;
      });
    };
  }

  function bindAtcClickedListener() {
    document.addEventListener('atc_clicked', function() {
      cartItemCount = Math.max(1, cartItemCount + 1);
    });

    document.addEventListener('click', function(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var atcButton = target.closest('[name="add"], [data-add-to-cart="true"], .product-form__submit');
      if (!atcButton) return;

      cartItemCount = Math.max(1, cartItemCount + 1);
    }, true);
  }

  function bindDesktopExitIntent() {
    if (isMobile) return;

    document.addEventListener('mouseout', function(event) {
      if (!event) return;
      if (event.relatedTarget) return;
      if (typeof event.clientY !== 'number' || event.clientY > 0) return;
      attemptPopup(false);
    });
  }

  function resetInactivityTimer() {
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
    }

    inactivityTimer = setTimeout(function() {
      attemptPopup(false);
    }, INACTIVITY_MS);
  }

  function bindMobileInactivityFallback() {
    if (!isMobile) return;

    ['touchstart', 'touchmove', 'scroll', 'click', 'keydown'].forEach(function(eventName) {
      window.addEventListener(eventName, resetInactivityTimer, { passive: true });
    });

    resetInactivityTimer();
  }

  function bindMobileBackIntercept() {
    if (!isMobile || !window.history || !window.history.pushState) return;

    var sentinelKey = '__stExitIntentSentinel';
    try {
      var currentState = window.history.state && typeof window.history.state === 'object' ? window.history.state : {};
      if (!currentState.__stExitIntentBase) {
        window.history.replaceState(Object.assign({}, currentState, { __stExitIntentBase: true }), document.title, window.location.href);
      }

      window.history.pushState({ __stExitIntentBase: true, __stExitIntentSentinel: true }, document.title, window.location.href);

      window.addEventListener('popstate', function(event) {
        var state = event && event.state ? event.state : {};
        if (state && state[sentinelKey]) return;

        var opened = attemptPopup(false);

        // Re-arm only when we intercepted and opened, otherwise allow the next back to leave the page.
        if (opened) {
          window.history.pushState({ __stExitIntentBase: true, __stExitIntentSentinel: true }, document.title, window.location.href);
        }
      });
    } catch (error) {
      // History APIs can fail in some embedded browsers.
    }
  }

  function init() {
    var state = resetStateIfNewDay();
    if (Number(state.lastAddToCartTime) > 0) {
      lastAddToCartTime = Number(state.lastAddToCartTime);
    }

    bindAtcClickedListener();
    patchFetch();
    bindDesktopExitIntent();
    bindMobileBackIntercept();
    bindMobileInactivityFallback();

    refreshCartCount();

    if (debugForceOpen) {
      setTimeout(function() {
        attemptPopup(true);
      }, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
